import React from 'react';
import "./socials.css";
import { Box } from '@mui/system';
import { Button, Grid } from '@mui/material';
import { GitHub, Google, LinkedIn, Phone } from '@mui/icons-material';
import EmailButton from './EmailButton';
import PhoneButton from './PhoneButton';
import LinkedInButton from './LinkedInButton';

const Socials_slide = () => {

    return (
        <Box className='slide' id='socials_slide'>
            <Grid
                container
                spacing={2}
                justifyContent="center"
                sx={{
                    flexDirection: {
                        xs: 'column',
                        sm: 'column',
                        md: 'row',
                    },
                    alignItems: 'center',
                    gap: {
                        xs: '20px',
                        sm: '30px',
                        md: '50px',
                        lg: '70px',
                    },
                    padding: {
                        xs: '20px',
                        sm: '30px',
                        md: '40px',
                        lg: '50px',
                    },
                }}
            >

                <EmailButton
                    email="info@billetprecision.ca"
                    iconTextGap="15px"
                    emailFontSize="16px"
                    emailIconScale="1.7"
                    sx={{
                        flexDirection: {
                            xs: 'column',
                            sm: 'row',
                        },
                        '& .email-text': {
                            fontSize: {
                                xs: '12px',
                                sm: '14px',
                                md: '16px',
                                lg: '18px',
                            },
                        },
                        '& .email-icon svg': {
                            transform: {
                                xs: 'scale(1.3)',
                                sm: 'scale(1.5)',
                                md: 'scale(1.7)',
                                lg: 'scale(2.0)',
                            },
                        },
                    }}
                />

                <PhoneButton
                    phone="+1 2345678910"
                    phoneFontSize="16px"
                    phoneIconScale="1.8"
                    iconTextGap="15px"
                    sx={{
                        flexDirection: {
                            xs: 'column',
                            sm: 'row',
                        },
                        '& .phone-text': {
                            fontSize: {
                                xs: '12px',
                                sm: '14px',
                                md: '16px',
                                lg: '18px',
                            },
                        },
                        '& .phone-icon svg': {
                            transform: {
                                xs: 'scale(1.3)',
                                sm: 'scale(1.5)',
                                md: 'scale(1.7)',
                                lg: 'scale(2.0)',
                            },
                        },
                    }}
                />

                <LinkedInButton
                    linkedin="https://www.linkedin.com/company/billet-precision-ltd-/"
                    linkedinFontSize="16px"
                    linkedinIconScale="1.8"
                    iconTextGap="15px"
                    sx={{
                        flexDirection: {
                            xs: 'column',
                            sm: 'row',
                        },
                        '& .linkedin-text': {
                            fontSize: {
                                xs: '12px',
                                sm: '14px',
                                md: '16px',
                                lg: '18px',
                            },
                        },
                        '& .linkedin-icon svg': {
                            transform: {
                                xs: 'scale(1.3)',
                                sm: 'scale(1.5)',
                                md: 'scale(1.7)',
                                lg: 'scale(2.0)',
                            },
                        },
                    }}
                />

            </Grid>
        </Box>
    );
};

export default Socials_slide;
